var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_9405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 1000V763.23L354.721 696.187L401.676 723.71L231.86 1000H109Z",
    fill: "#0DA898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.656 642.905V494.35L220.563 482V634.436L138.656 642.905Z",
    fill: "#0DA898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891 715.241L589.851 622.086V693.364L759.313 990.473H891V715.241Z",
    fill: "#0DA898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 1000V763.23L354.721 696.187L401.676 723.71L231.86 1000H109Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.656 642.905V494.35L220.563 482V634.436L138.656 642.905Z",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891 715.241L589.851 622.086V693.364L759.313 990.473H891V715.241Z",
    stroke: "black",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_9405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL2);
export default __webpack_public_path__ + "static/media/l2.0af708eb66d83dce5ec2f66b005549f0.svg";
export { ForwardRef as ReactComponent };